<template>
  <div class="customcheckerboard-button-nav" v-show="navigation.activeView !== 'checkerboardAlmostDone'">
    <button
      :class="[
        'customcheckerboard-button-nav-cta customcheckerboard-button-nav-cta--first button secondary',
        { expanded: !isMainApp || isMobile },
        { disabled: !enableControls }
      ]"
      type="button"
      @click="goBack"
      v-show="false"
    >{{ translations.customCheckerboardBack }} </button>
    <button
      v-tooltip="{
        placement: 'top-center',
        offset: 8,
        trigger: 'manual',
        show: isTooltipOpen && disableNextButton,
        classes: 'customcheckerboard-button-nav-tooltip',
        content: colorSelectionTooltipContent,
      }"
      @click="goNext"
      :class="[
        'customcheckerboard-button-nav-cta button primary',
        { expanded: !isMainApp || isMobile },
        { disabled: disableNextButton || !enableControls },
        { fullwidth: !isConfirmDesignViewActive }
      ]"
      type="button"
      v-show="showNextButton"
    > {{ translations.customCheckerboardNext }} <img :src="`${assetsPath}/svg/customizer/icon-next.svg`" alt="" class="customcheckerboard-button-nav-next-icon" /></button>
    <button
      :class="[
        'customcheckerboard-button-nav-cta button primary',
        { expanded: !isMainApp || isMobile },
        { disabled: !enableControls },
        'fullwidth'
      ]"
      type="button"
      v-show="isConfirmDesignViewActive"
      @click="onClickFinish"
    > {{ translations.customCheckerboardFinish }}
    </button>
  </div>
</template>

<script>
export default {
  name: "customcheckerboardButtonNav",
  props: ['isMainApp'],
  data() {
    return {
      isTooltipOpen: false,
      buttonClicked: false
    }
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    assetsPath() {
      return this.$store.state.endPoints.customcheckerboard.customsAssets;
    },
    navigation() {
      return this.$store.state.customCheckerboard.navigation;
    },
    isConfirmDesignViewActive() {
      return this.navigation.activeView === 'checkerboardConfirmDesign';
    },
    showNextButton() {
      return !this.isConfirmDesignViewActive && this.navigation.activeViewIndex < this.navigation.views.length - 1;
    },
    enableControls() {
      return this.$store.state.customCheckerboard.enableControls;
    },
    disableNextButton() {
      switch(this.navigation.activeViewIndex) {
        case 0:
          return !this.colorSelectionIsComplete;
        case 1:
          return !this.canvasConfig.size;
        case 4:
          return !this.colorSelectionIsComplete;
        default:
          return false;
      }
    },
    colorSelectionIsComplete() {
      return this.canvasConfig.color1 && this.canvasConfig.color2;
    },
    // when the button is not enabled it will show the tooltip
    colorSelectionTooltipContent() {
      return this.disableNextButton ? `<div>
        <div class="customcheckerboard-button-nav-tooltip-error-icon">!</div>
        <p>
          ${this.translations.colorSelectionTooltip}
        </p>
      </div>` : null;
    },
    isMobile() {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    },
    canvasConfig() {
      return this.$store.state.customCheckerboard.canvasConfig;
    },
  },
  methods: {
    goBack() {
      if (!this.enableControls) return;
      this.buttonClicked = true;
      this.$store.commit("customCheckerboard/SET_ENABLE_CONTROLS", false);
      this.isTooltipOpen = false;
      this.$eventBus.$emit('customcheckerboard-go-to-previous-step');
      // This will prevent that the user can click twice quickly
      setTimeout(() => {
        this.buttonClicked = false;
      }, 50);
    },
    goNext() {
      if (this.disableNextButton) {
        this.isTooltipOpen = true;
        setTimeout(() => this.isTooltipOpen = false, 3000);
      } else {
        if (this.$store.getters['utils/useEcomDataLayerFormat']) {
          this.$checkerboardDataLayer.logAnalyticsEvent({eventLabel: this.$checkerboardDataLayer.labels.next});
        }
        if (!this.enableControls || this.buttonClicked) return;
        this.buttonClicked = true;
        this.$store.commit("customCheckerboard/SET_ENABLE_CONTROLS", false);
        this.isTooltipOpen = false;
        this.$eventBus.$emit('customcheckerboard-go-to-next-step');
        // This will prevent that the user can click twice quickly
        setTimeout(() => {
          this.buttonClicked = false;
        }, 50);
      }
    },
    onClickFinish() {
      this.$eventBus.$emit('customcheckerboard-finish-clicked');
    },
  },
};
</script>
